import h from "../../core/createElement";
import ReportModal from "../../modals/report";
import Box from "../box";
import Btn from "../btn";
import SearchBar from "../search_bar";
import ReportList from "./report_list";

export default function ReportListBox({ shared, name = "report_box", onDismissHighlight, onHighlight, refresh_files, set_group }) {
    const
        inner_shared = {},
        report_btns = [
            <SearchBar placeholder="Pesquisa por nome" shared={inner_shared} name="report_search_bar" onSearch={v => shared.group_id && search_report_by_name(v)} />,
            <Btn color="green" icon="assets/image/plus.svg" onClick={() => new_report()} />
        ];

    const
        fetch_reports = (...args) => inner_shared.report_list.fetch_report(...args),
        highlight_card_by_id = (id) => inner_shared.report_list.highlight_card_by_id(id),
        search_report_by_name = (v) => fetch_reports({ name: v }, 1);

    const
        refresh_reports = () => {
            inner_shared.report_search_bar.close();
            return inner_shared.report_list.fetch_report({}, 1);
        },
        modal_refresh_reports = () => {
            onDismissHighlight && onDismissHighlight();
            return refresh_reports();
        },
        open_report_by_id = (id) => {
            ReportModal.show({
                group_id: shared.group_id, id,
                updated: async () => { await refresh_reports() },
                refresh: refresh_files,
                refresh_reports: modal_refresh_reports,
                got_to_cloned_one: (d) => got_to_cloned_one(d)
            })
        },
        new_report = () => {
            if (!+shared.group_id) return popupAlerts.danger("Crie uma aplicação(grupo) para prosseguir!");

            ReportModal.show({
                group_id: shared.group_id,
                created: async (data) => {
                    await refresh_reports()
                    open_report_by_id(data.id);
                },
                refresh_reports: modal_refresh_reports
            });
        },
        got_to_cloned_one = async (report_cloned) => {
            set_group && set_group(report_cloned.group_id);
            await refresh_reports();
            highlight_card_by_id(report_cloned.id);
            onHighlight && await onHighlight(report_cloned);
            open_report_by_id(report_cloned.id);
        };

    shared[name] = {
        refresh_reports,
        fetch_reports,
        dismiss_all_cards_highlights: () => inner_shared.report_list.dismiss_all_cards_highlights()
    };

    Object.defineProperty(inner_shared, 'group_id', { get: () => shared.group_id });

    return (
        <Box title="Relatórios" containerClass="min-w-450" buttons={report_btns}>
            <ReportList
                cardClick={r => open_report_by_id(r.id)}
                shared={inner_shared}
                name="report_list"
                refresh_files={refresh_files}
                onCardHighlight={onHighlight}
                onCardDismissHighlight={onDismissHighlight}
                got_to_cloned_one={got_to_cloned_one}
            />
        </Box>
    )
}